var _excluded = ["label", "isActive", "alignIcon"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { asMultiStyleConfig } from '../../../../utils/theme';
import { secondaryButtonStyles, primaryButtonStyles } from './button';
import { getPadding } from '../../../../theme/components/action-bar';
var parts = ['container', 'button', 'iconButton', 'checkbox'];
var baseStyleContainer = {
  bg: 'blue.50',
  borderRadius: '0.188rem',
  padding: {
    base: '1rem'
  }
};
var buttonStyles = props => {
  var buttonCss = secondaryButtonStyles(props).button;
  if (props.variant === 'primary') {
    buttonCss = primaryButtonStyles(props).button;
  }
  return _objectSpread(_objectSpread({
    position: 'relative',
    border: '.063rem solid #0D4E8A',
    fontWeight: '700',
    letterSpacing: 'tight'
  }, buttonCss), {}, {
    borderRadius: '0.188rem',
    minWidth: '5.25rem'
  });
};
var iconButtonStyles = _ref => {
  var {
      label,
      isActive,
      alignIcon
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var buttonCss = secondaryButtonStyles(rest);
  if (rest.variant === 'primary') {
    buttonCss = _objectSpread(_objectSpread({}, buttonCss), primaryButtonStyles(rest).button);
  } else {
    buttonCss = _objectSpread(_objectSpread({}, buttonCss), {}, {
      bg: isActive ? 'blue.1140' : 'white',
      _hover: {
        bg: 'blue.1140'
      },
      border: '0'
    });
  }
  return _objectSpread(_objectSpread({}, buttonCss), {}, {
    fontSize: '1rem',
    display: 'inline-flex',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '1.375rem',
    fontWeight: 700,
    width: label ? 'auto' : '2.75rem',
    height: '2.75rem',
    py: '.625rem',
    pl: label && alignIcon ? getPadding(label.toString(), alignIcon.toString()).pl : 0,
    pr: label && alignIcon ? getPadding(label.toString(), alignIcon.toString()).pr : 0,
    '> svg': {
      height: '100%',
      width: {
        base: '.875rem',
        md: '1.25rem'
      },
      marginLeft: label ? '0.688rem' : 0,
      position: alignIcon === 'right' ? 'absolute' : 'static',
      right: '0.875rem'
    }
  });
};
var baseStyle = () => ({
  container: baseStyleContainer,
  button: buttonStyles,
  iconButton: iconButtonStyles,
  checkbox: {
    color: 'blue.275',
    fontWeight: 'bold'
  }
});
export var ActionBar = asMultiStyleConfig({
  parts,
  baseStyle
});